import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
  standalone: false
})
export class WarningModalComponent implements OnInit {
  public title: string;
  public description: string;
  public btnText: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, description: string, btnText: string }) { }

  ngOnInit(): void {
    const { title, description, btnText } = this.data;

    this.title = title;
    this.description = description;
    this.btnText = btnText;
  }
}
